import { render, staticRenderFns } from "./ParkingPrimaryTabItem.vue?vue&type=template&id=b9d63a7e&scoped=true"
import script from "./ParkingPrimaryTabItem.vue?vue&type=script&lang=js"
export * from "./ParkingPrimaryTabItem.vue?vue&type=script&lang=js"
import style0 from "./ParkingPrimaryTabItem.vue?vue&type=style&index=0&id=b9d63a7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d63a7e",
  null
  
)

export default component.exports